import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Box, Flex, Heading, Text } from "rebass";
// import {Divider} from 'reakit'
import { sortBy, uniqBy } from "lodash-es";
import { PostCard } from "../../components/Cards";
import { AddButton } from "../../components/Base/Buttons";
import { Content, DesktopBox, MobileHeader } from "../../components/Base";
import Loading from "../../components/Base/Loading";
import styled from "styled-components";
import "./draft-js-style.css";

import HealthFormReminder from "../../components/Modals/HealthFormReminder";

const Divider = styled(Box)`
  width: 100%;
  height: 1px;
  background-color: #808080;
  opacity: 0.1;
`;

class Home extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentPinned: 1,
      loading: false,
      pinned: [],
      important: [],
      posts: [],
      requests: 0,
      showHealthReminder: false,
    };
  }

  componentDidMount() {
    const { isFaculty, profile } = this.props;
    if (isFaculty) {
      this.requestListener = this.newRequestListener();
    }

    let today = new Date();
    today.setHours(0, 0, 0, 0);
    let todayEpoch = Math.floor(today.getTime() / 1000);

    // Health reminder
    /*
    if (isFaculty) {
      this.healthReminderListener = this.props.firebase
        .faculty(profile.id)
        .onSnapshot((snapshot) => {
          let user = snapshot.data();
          if (user) {
            this.setState({
              showHealthReminder: user.health_last_updated < todayEpoch,
            });
          }
        });
    } else {
      this.healthReminderListener = this.props.firebase
        .student(profile.id)
        .onSnapshot((snapshot) => {
          let user = snapshot.data();
          if (user) {
            this.setState({
              showHealthReminder: user.health_last_updated < todayEpoch,
            });
          }
        });
    }
    */
  }

  newRequestListener = () => {
    const { profile } = this.props;
    return this.props.firebase
      .posts()
      .where("status", "==", 0)
      .where("faculty", "array-contains", profile.id)
      .onSnapshot((snapshot) => {
        this.setState({ requests: snapshot.docs.length });
      });
  };

  setPrevPage = () => {
    const { currentPinned } = this.state;
    if (currentPinned > 1) {
      this.setState({ currentPinned: currentPinned - 1 });
    }
  };

  setNextPage = () => {
    const { currentPinned } = this.state;
    const { pinned } = this.props;
    let nextPage = currentPinned + 1;
    if (nextPage > Math.ceil(pinned.length / 3)) {
      nextPage = 1;
    }

    this.setState({ currentPinned: nextPage });
  };

  getCurrentPinnedPage = () => {
    const { currentPinned } = this.state;
    const { pinned } = this.props;

    let lastIndex = currentPinned * 3;
    let firstIndex = lastIndex - 3;
    let result = pinned.slice(firstIndex, lastIndex);
    if (result.length < 3 && currentPinned > 1) {
      let dif = 3 - result.length;
      lastIndex = lastIndex - dif;
      firstIndex = firstIndex - dif;
      result = pinned.slice(firstIndex, lastIndex);
    }
    return result;
  };

  takeUserToHealthForm = () => {
    this.props.history.push("/app/health");
  };

  componentWillUnmount() {
    const { isFaculty } = this.props;
    if (isFaculty) this.requestListener();
    //this.healthReminderListener();
  }

  /*
	filterAndSortPosts = (posts, profile, isFaculty) => {
		let filteredPosts = [];
		if (isFaculty) {
			filteredPosts = posts
		} else {
			filteredPosts = posts.filter(post => post.gender_tag.length === 0 || post.gender_tag.includes(profile.gender));
			filteredPosts = filteredPosts.filter(post => post.dorm_tag.length === 0 || post.dorm_tag.includes(profile.dorm));
			filteredPosts = filteredPosts.filter(post => post.grade_tag.length === 0 || post.grade_tag.includes(profile.grade.toString()))
		}
		let sortedPosts = sortBy(filteredPosts, 'post_time');
		sortedPosts = sortedPosts.reverse();
		return sortedPosts;
	};
	**/

  newFilterAndSortPosts = (posts, profile, isFaculty) => {
    const { school } = this.props;
    let filteredPosts = [];
    if (isFaculty) {
      filteredPosts = [
        ...posts.filter((post) => post.generalFaculty === "All"),
        ...posts.filter(
          (post) =>
            post.gender_faculty != null &&
            (post.gender_faculty.length === 0 ||
              post.gender_faculty.includes(profile.gender))
        ),
      ];

      let removedNone = filteredPosts.filter(
        (post) => post.generalFaculty !== "None"
      );

      filteredPosts = [
        ...posts.filter((post) => post.creator_uid === profile.id),
        ...removedNone,
      ];
    } else {
      filteredPosts = posts.filter((post) => post.generalStudent === "All");
      let tagFilteredPosts = posts.filter(
        (post) =>
          post.gender_tag.length === 0 ||
          post.gender_tag.includes(profile.gender)
      );
      // find dorm in school, then check if sub_dorm of dorm includes profile.sub_dorm
      tagFilteredPosts = tagFilteredPosts.filter(
        (post) =>
          post.dorm_tag.length === 0 ||
          (school.dorms &&
            school.dorms.filter(
              (dorm) =>
                post.dorm_tag.includes(dorm.id) &&
                dorm.sub_dorms.filter((sub_dorm) =>
                  sub_dorm.id.includes(profile.sub_dorm)
                ).length > 0
            ).length > 0)
      );
      tagFilteredPosts = tagFilteredPosts.filter(
        (post) =>
          post.grade_tag.length === 0 ||
          post.grade_tag.includes(profile.grade.toString())
      );

      let removedNone = tagFilteredPosts.filter(
        (post) => post.generalStudent !== "None"
      );

      filteredPosts = [
        ...filteredPosts,
        ...removedNone,
        ...posts.filter((post) => post.creator_uid === profile.id),
      ];
    }

    let uniqPosts = uniqBy(filteredPosts, "id");
    let sortedPosts = sortBy(uniqPosts, "post_time");
    sortedPosts = sortedPosts.reverse();
    return sortedPosts;
  };

  render() {
    const { requests, showHealthReminder } = this.state;
    const { isFaculty, pinned, posts, profile, loading } = this.props;

    // const sortedPinned = this.filterAndSortPosts(pinned, profile, isFaculty);
    // const sortedPosts = this.filterAndSortPosts(posts, profile, isFaculty);
    const sortedPinned = this.newFilterAndSortPosts(pinned, profile, isFaculty);
    const sortedPosts = this.newFilterAndSortPosts(posts, profile, isFaculty);

    // const currentPinnedPage = this.getCurrentPinnedPage()
    return (
      <Box p={[0, 3]}>
        <HealthFormReminder
          visible={showHealthReminder}
          toggle={() => this.setState({ showHealthReminder: false })}
          handleConfirm={this.takeUserToHealthForm}
        />

        <MobileHeader bg={"white"}>
          <Heading bg={"white"} py={2}>
            Hello, {profile && profile.first_name}
          </Heading>
        </MobileHeader>

        <Box pt={[0, 1]} pl={[0, 3]} pb={[0, 3]}>
          <AddButton to="/app/posts/new" />
        </Box>
        {loading ? (
          <Loading />
        ) : (
          <Content px={[0, 3]}>
            <Box>
              {isFaculty && requests > 0 && (
                <Box mb={[3]} ml={[2, 0]}>
                  <Text fontSize="21px" ml={"3px"} fontWeight={800}>
                    {requests} student{requests.length > 0 && "s"} requested to
                    post
                  </Text>
                  <Link to={"/app/posts/approve"}>
                    <Text
                      ml={"3px"}
                      mt={1}
                      fontSize="15"
                      fontWeight={400}
                      color="#969a9b"
                      fontFamily="sans"
                    >
                      Click to view >
                    </Text>
                  </Link>
                </Box>
              )}
            </Box>

            <Box>
              <DesktopBox ml={1}>
                <Text pt={3} fontSize={"32px"} fontWeight={800} lineHeight={1}>
                  Posts
                </Text>
                <Text pt={2} pb={3} fontSize={"16px"} fontWeight={400}>
                  See what's going on at Hill.
                </Text>
              </DesktopBox>
              <Flex
                flexWrap="wrap"
                flexDirection={["column", "row"]}
                p={[3, 0]}
                pt={[3, 0]}
                mt={"-20px"}
              >
                {!sortedPosts.length && !sortedPinned.length && (
                  <Text pt={2} pb={3} ml={1} fontSize={"16px"} fontWeight={400}>
                    There are currently no posts.
                  </Text>
                )}
                {!loading ? (
                  sortedPinned.map((post) => (
                    <Box key={post.id} width={1}>
                      <Box mx={"auto"} width={[1, 0.6]}>
                        <PostCard
                          pinnedPost={true}
                          post={post}
                          profile={profile}
                          {...this.props}
                        />
                      </Box>
                      <Box width={1} pr={1}>
                        <Divider />
                      </Box>
                    </Box>
                  ))
                ) : (
                  <Text></Text>
                )}

                {!loading ? (
                  sortedPosts.map((post) => (
                    <Box key={post.id} width={1}>
                      <Box mx={"auto"} width={[1, 0.6]}>
                        <PostCard
                          post={post}
                          profile={profile}
                          {...this.props}
                        />
                      </Box>
                      <Box width={1} pr={1}>
                        <Divider />
                      </Box>
                    </Box>
                  ))
                ) : (
                  <Text></Text>
                )}
              </Flex>
            </Box>
          </Content>
        )}
      </Box>
    );
  }
}

export default Home;
